import React from 'react';
import { CONFIG } from '../config/global';

const PricingSection: React.FC = () => {
  const handleContactClick = () => {
    window.open(CONFIG.calendlyLink, '_blank');
  };

  return (
    <section className="py-20 bg-gray-50 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-text mb-6">
          Pricing
        </h2>
        <div className="w-24 h-1 bg-primary mx-auto mb-12"></div>
        
        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12 mb-8">
          <h3 className="text-2xl font-bold text-text mb-6">
            Flexible Plans for Every Trainer
          </h3>
          <p className="text-lg text-text/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            Whether you're just starting out or managing a large client base, we have a plan that fits your needs. 
            Our pricing is designed to grow with your business, ensuring you only pay for what you need.
          </p>
          
          <button
            onClick={handleContactClick}
            className="bg-primary hover:bg-primary/90 text-white font-semibold py-4 px-8 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
          >
            Get Your Custom Quote
          </button>
        </div>
        
        <p className="text-text/60 text-sm">
          Schedule a demo to see Emerik in action and get a personalized pricing plan for your business.
        </p>
      </div>
    </section>
  );
};

export default PricingSection;
